const anchor = "_rsafom05o";

export { anchor };
import "./printer.anchor.style.linaria.module.css";
//# sourceMappingURL=printer.anchor.style.js.map
